module.exports = __webpack_public_path__ + "static/media/shareIcon.94fb2a59.svg";